angular.module('statWashByarea', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/stat-wash-byarea/stat-wash-byarea.module.js